import { useState, useEffect } from "react";

export const useLessonData = (open, isAuthenticated, user, lessonData) => {
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [passes, setPasses] = useState([]);
  const [canSignData, setCanSignData] = useState({ 
    available: true, 
    has_pass: false, 
    is_on_waitlist: false, 
    waitlist_position: null,
    has_unpaid_debt: false,
    pass_expired: false,
    debt_amount: 0,
    debt_count: 0,
    debt_details: []
  });

  const fetchCanSignData = async () => {
    if (!isAuthenticated || !lessonData.lesson_id) return;

    const idToken = await user.getIdToken();
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_ADDRESS}/can_sign_to_lesson/${lessonData.lesson_id}`,
        { headers: { Authorization: `Bearer ${idToken}` } }
      );
      const data = await res.json();
      setCanSignData({
        available: data.available,
        has_pass: data.has_pass,
        is_on_waitlist: data.is_on_waitlist || false,
        waitlist_position: data.waitlist_position || null,
        has_unpaid_debt: data.has_unpaid_debt || false,
        pass_expired: data.pass_expired || false,
        debt_amount: data.debt_amount || 0,
        debt_count: data.debt_count || 0,
        debt_details: data.debt_details || []
      });
    } catch (error) {
      console.error('Error checking lesson availability:', error);
      setCanSignData({
        available: false,
        has_pass: false,
        is_on_waitlist: false,
        waitlist_position: null,
        has_unpaid_debt: false,
        pass_expired: false,
        debt_amount: 0,
        debt_count: 0,
        debt_details: []
      });
    }
  };

  const fetchPasses = async () => {
    if (!isAuthenticated || !lessonData.lesson_id) return;

    const idToken = await user.getIdToken();
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_ADDRESS}/pass/mine?active=true&lesson_id=${lessonData.lesson_id}`,
        { headers: { Authorization: `Bearer ${idToken}` } },
      );
      const data = await res.json();
      if (Array.isArray(data.objects)) {
        // Check if any pass has unlimited lessons for this lesson type
        const unlimitedPasses = data.objects.filter((pass) =>
          pass.lesson_categories_for_pass.some(
            (category) => category.is_unlimited
          )
        );

        // If there are unlimited passes, show only those; otherwise show all passes
        setPasses(unlimitedPasses.length > 0 ? unlimitedPasses : data.objects);
      } else {
        setPasses([]);
      }
    } catch {
      setPasses([]);
    }
  };

  const refreshData = async () => {
    setIsDataLoading(true);
    await fetchCanSignData();
    await fetchPasses();
    setIsDataLoading(false);
  };

  useEffect(() => {
    if (open && isAuthenticated) {
      refreshData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isAuthenticated]);

  return {
    isDataLoading,
    passes,
    canSignData,
    fetchCanSignData,
    fetchPasses,
    refreshData
  };
};
